// MainPage.js
import React, { useState } from 'react';
import '../aviso_legal/aviso_legal.css'; // Add custom styles for the main content
import './cookie_policy.css'; // Add custom styles for the main content
import { useTranslation } from 'react-i18next';

const PoliticaCookies = () => {
    const { t, i18n } = useTranslation('politica_cookies');

    return (
        <main className="main-content">
            {/* Main Section */}
            <section className="dosier">
                <div className="dosier__image">
                    <img src={`${process.env.PUBLIC_URL}/images/Imagen-7-scaled.jpg`} alt="logo" />
                    <div className="dosier__image__text"><span>{t('cookiePolicy.title')}</span></div> 
                </div>
            </section>

            <section className="aviso_legal__info">
                <div className="aviso_legal__info__box">
                    <div className="cookie-policy">
                        <h1>{t('cookiePolicy.title')}</h1>
                        <p>
                            {t('cookiePolicy.intro1')} <a href="http://www.quiropracticosfuengirola.com">www.quiropracticosfuengirola.com</a>. {t('cookiePolicy.intro2')}
                        </p>
                        <p>{t('cookiePolicy.consentNotice')}</p>
                        <p>{t('cookiePolicy.modificationNotice')}</p>

                        <h2>{t('cookiePolicy.generalInfo.title')}</h2>
                        <h3>{t('cookiePolicy.generalInfo.whatAreCookies.title')}</h3>
                        <p>{t('cookiePolicy.generalInfo.whatAreCookies.description1')}</p>
                        <p>{t('cookiePolicy.generalInfo.whatAreCookies.description2')}</p>
                        <p>{t('cookiePolicy.generalInfo.whatAreCookies.description3')}</p>
                        <p>{t('cookiePolicy.generalInfo.whatAreCookies.description4')}</p>

                        <h3>{t('cookiePolicy.generalInfo.typesOfCookies.title')}</h3>
                        <p>{t('cookiePolicy.generalInfo.typesOfCookies.exemptCookies')}</p>
                        <ul>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.userInput')}</li>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.authentication')}</li>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.security')}</li>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.mediaSession')}</li>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.loadBalancing')}</li>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.interfaceCustomization')}</li>
                            <li>{t('cookiePolicy.generalInfo.typesOfCookies.examples.socialPlugin')}</li>
                        </ul>

                        <h3>{t('cookiePolicy.generalInfo.cookieOwnership.title')}</h3>
                        <p>{t('cookiePolicy.generalInfo.cookieOwnership.ownCookies')}</p>
                        <p>{t('cookiePolicy.generalInfo.cookieOwnership.thirdPartyCookies')}</p>

                        <h3>{t('cookiePolicy.generalInfo.cookieDuration.title')}</h3>
                        <p>{t('cookiePolicy.generalInfo.cookieDuration.sessionCookies')}</p>
                        <p>{t('cookiePolicy.generalInfo.cookieDuration.persistentCookies')}</p>
                        <p>{t('cookiePolicy.generalInfo.cookieDuration.analyticsCookies')}</p>
                        <p>{t('cookiePolicy.generalInfo.cookieDuration.socialMediaCookies')}</p>

                        <h2>{t('cookiePolicy.cookiesUsed.title')}</h2>
                        <p>{t('cookiePolicy.cookiesUsed.description')}</p>
                        <table>
                            <thead>
                                <tr>
                                    <th>{t('cookiePolicy.cookiesUsed.tableHeaders.name')}</th>
                                    <th>{t('cookiePolicy.cookiesUsed.tableHeaders.owner')}</th>
                                    <th>{t('cookiePolicy.cookiesUsed.tableHeaders.until')}</th>
                                    <th>{t('cookiePolicy.cookiesUsed.tableHeaders.purpose')}</th>
                                    <th>{t('cookiePolicy.cookiesUsed.tableHeaders.type')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>_ga</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._ga.owner')}</td>
                                    <td>2022-04-21T16:18:25.000Z</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._ga.purpose')}</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._ga.type')}</td>
                                </tr>
                                <tr>
                                    <td>_gat</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._gat.owner')}</td>
                                    <td>2020-04-21T16:19:25.000Z</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._gat.purpose')}</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._gat.type')}</td>
                                </tr>
                                <tr>
                                    <td>_gid</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._gid.owner')}</td>
                                    <td>2020-04-22T16:18:25.000Z</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._gid.purpose')}</td>
                                    <td>{t('cookiePolicy.cookiesUsed.tableData._gid.type')}</td>
                                </tr>
                            </tbody>
                        </table>

                        <p>{t('cookiePolicy.cookiesUsed.discrepancyNotice')}</p>

                        <h2>{t('cookiePolicy.disableCookies.title')}</h2>
                        <p>{t('cookiePolicy.disableCookies.description')}</p>
                        <ul>
                            <li>{t('cookiePolicy.disableCookies.browsers.chrome')}</li>
                            <li>{t('cookiePolicy.disableCookies.browsers.chromeAndroid')}</li>
                            <li>{t('cookiePolicy.disableCookies.browsers.firefox')}</li>
                            <li>{t('cookiePolicy.disableCookies.browsers.explorer')}</li>
                            <li>{t('cookiePolicy.disableCookies.browsers.safari')}</li>
                            <li>{t('cookiePolicy.disableCookies.browsers.safariIOS')}</li>
                            <li>{t('cookiePolicy.disableCookies.browsers.edge')}</li>
                        </ul>
                        <p>{t('cookiePolicy.disableCookies.googleAnalytics')}</p>
                        <p>{t('cookiePolicy.disableCookies.yourOnlineChoices')}</p>

                        <h2>{t('cookiePolicy.modification.title')}</h2>
                        <p>{t('cookiePolicy.modification.description')}</p>

                        <h2>{t('cookiePolicy.responsibilities.title')}</h2>
                        <p>{t('cookiePolicy.responsibilities.description1')}</p>
                        <p>{t('cookiePolicy.responsibilities.description2')}</p>
                        <p>{t('cookiePolicy.responsibilities.description3')}</p>
                        <p>{t('cookiePolicy.responsibilities.description4')}</p>
                        <p>{t('cookiePolicy.responsibilities.description5')}</p>
                        <p>{t('cookiePolicy.responsibilities.description6')}</p>

                        <p>{t('cookiePolicy.contactNotice')}</p>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default PoliticaCookies;
